import { isEqual } from 'lodash';

// Fields the backend may recalculate as a side effect of autosave (total price recalculation,
// capacity-driven delivery dates, auto-assigned pallet groups). Some of these (e.g. palletInformation)
// can *also* be edited directly by the user, so we can't just treat them as "server owned" and always
// overwrite - we only apply the server's value if it still matches what was actually sent in this
// request. If the user changed the field again while the request was in flight, the newer local value
// wins instead and gets reconciled correctly on the next autosave round trip.
const RECALCULATED_ORDER_FIELDS = [
    'orderTotalPriceWithoutVat',
    'vatAmount',
    'orderTotalPrice',
    'deliveryTime',
    'earlyDeliveryTime',
];
const RECALCULATED_ROW_FIELDS = ['palletInformation', 'totalPriceWithoutVat', 'unitPriceWithoutVat'];

// currentOrder: the order as it currently exists in the redux store (may have been edited again
//               since sentSnapshot was taken)
// sentSnapshot: a deep clone of the order exactly as it was sent to the autosave endpoint
// serverOrder:  the authoritative, recalculated order returned by the autosave response
//
// Mutates and returns currentOrder. Caller is responsible for passing in a clone if the original
// must stay untouched (e.g. because it's still referenced elsewhere).
export function mergeAutosaveResult(currentOrder, sentSnapshot, serverOrder) {
    if (currentOrder == null || sentSnapshot == null || serverOrder == null) return currentOrder;

    for (const field of RECALCULATED_ORDER_FIELDS) {
        if (isEqual(currentOrder[field], sentSnapshot[field])) {
            currentOrder[field] = serverOrder[field];
        }
    }

    if (Array.isArray(currentOrder.orderedFilters)) {
        const sentRowsById = new Map((sentSnapshot.orderedFilters || []).map((r) => [r.id, r]));
        const serverRowsById = new Map((serverOrder.orderedFilters || []).map((r) => [r.id, r]));

        for (const row of currentOrder.orderedFilters) {
            const sentRow = sentRowsById.get(row.id);
            const serverRow = serverRowsById.get(row.id);
            if (sentRow == null || serverRow == null) continue;

            for (const field of RECALCULATED_ROW_FIELDS) {
                if (isEqual(row[field], sentRow[field])) {
                    row[field] = serverRow[field];
                }
            }
        }
    }

    return currentOrder;
}

export default mergeAutosaveResult;
